"use strict";
var _a;
exports.__esModule = true;
exports.safeUrl = exports.getBusinessLinks = exports.isTryingOrdering = exports.isBusiness = exports.getDaysLeft = exports.formatAddress = exports.UserPatchType = exports.BusinessLinkType = exports.ReferralSource = exports.EuroEquivalences = exports.CurrencyCode = void 0;
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Ron"] = "ron";
    CurrencyCode["Mdl"] = "mdl";
    CurrencyCode["Eur"] = "eur";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
exports.EuroEquivalences = (_a = {},
    _a[CurrencyCode.Ron] = 4.9,
    _a[CurrencyCode.Mdl] = 20.1,
    _a[CurrencyCode.Eur] = 1,
    _a);
var ReferralSource;
(function (ReferralSource) {
    ReferralSource["Facebook"] = "facebook";
    ReferralSource["Google"] = "google";
    ReferralSource["None"] = "none";
})(ReferralSource = exports.ReferralSource || (exports.ReferralSource = {}));
var BusinessLinkType;
(function (BusinessLinkType) {
    BusinessLinkType["NutritionalValuesExternal"] = "nutritionalValuesExternal";
    BusinessLinkType["Facebook"] = "facebook";
    BusinessLinkType["Instagram"] = "instagram";
    BusinessLinkType["PhoneNumber"] = "phoneNumber";
    BusinessLinkType["TripAdvisor"] = "tripAdvisor";
})(BusinessLinkType = exports.BusinessLinkType || (exports.BusinessLinkType = {}));
var UserPatchType;
(function (UserPatchType) {
    UserPatchType["WifiInfo"] = "wifiInfo";
    UserPatchType["Location"] = "location";
    UserPatchType["BusinessMedium"] = "businessMedium";
    UserPatchType["DefaultCurrency"] = "defaultCurrency";
    UserPatchType["PartyMode"] = "partyMode";
    UserPatchType["IsUsingPartyMode"] = "isUsingPartyMode";
    UserPatchType["InPartyMode"] = "inPartyMode";
    UserPatchType["FromAdminInterface"] = "fromAdminInterface";
    UserPatchType["IsUsingMenuSections"] = "isUsingMenuSections";
    UserPatchType["DefaultMenuLanguage"] = "defaultMenuLanguage";
    UserPatchType["OrderingEnableTableOrdering"] = "orderingEnableTableOrdering";
    UserPatchType["OrderingEnableCallWaiter"] = "orderingEnableCallWaiter";
    UserPatchType["StartOrderingTrial"] = "startOrderingTrial";
    UserPatchType["CustomMenuMessage"] = "customMenuMessage";
    UserPatchType["Schedule"] = "schedule";
    UserPatchType["InOfflineMode"] = "inOfflineMode";
    UserPatchType["InMaintenanceMode"] = "inMaintenanceMode";
    UserPatchType["ReservationSettings"] = "reservationSettings";
})(UserPatchType = exports.UserPatchType || (exports.UserPatchType = {}));
function formatAddress(addressObject) {
    var _a, _b, _c, _d;
    if (!addressObject) {
        return '';
    }
    var address_components = addressObject.address_components;
    var streetName = ((_a = address_components.find(function (x) { return x.types.includes('route'); })) === null || _a === void 0 ? void 0 : _a.short_name) || '';
    var streetNumber = (_b = address_components.find(function (x) { return x.types.includes('street_number'); })) === null || _b === void 0 ? void 0 : _b.short_name;
    var city = (_c = address_components.find(function (x) { return x.types.includes('locality'); })) === null || _c === void 0 ? void 0 : _c.short_name;
    var biggerCity = (((_d = address_components.find(function (x) { return x.types.includes('administrative_area_level_2'); })) === null || _d === void 0 ? void 0 : _d.short_name) || '').replace(/municipiul|comuna|orasul|orașul/i, '');
    var streetAddress = "".concat(streetName.replace(/strada/i, 'str.').replace(/bulevardul/i, 'Bd.') || '', " ").concat(streetNumber || '');
    var relevantCity = biggerCity || city;
    return [streetAddress, relevantCity].filter(function (x) { var _a; return (_a = (x || '')) === null || _a === void 0 ? void 0 : _a.trim(); }).join(', ');
}
exports.formatAddress = formatAddress;
var getDaysLeft = function (expiryDate) {
    var expiresTimestamp = expiryDate ? +new Date(expiryDate) : +new Date();
    var currentTimestamp = +new Date();
    var day = 24 * 60 * 60 * 1000;
    return Math.floor((expiresTimestamp - currentTimestamp) / day);
};
exports.getDaysLeft = getDaysLeft;
var isBusiness = function (user) {
    return (0, exports.getDaysLeft)(user === null || user === void 0 ? void 0 : user.subscriptionExpiresAt) > 0;
};
exports.isBusiness = isBusiness;
var isTryingOrdering = function (user) {
    var _a;
    return (0, exports.getDaysLeft)((_a = user === null || user === void 0 ? void 0 : user.ordering) === null || _a === void 0 ? void 0 : _a.trialExpiresAt) > 0;
};
exports.isTryingOrdering = isTryingOrdering;
var BusinessLinkTemplates = [
    {
        type: BusinessLinkType.Facebook,
        label: 'Facebook'
    },
    {
        type: BusinessLinkType.Instagram,
        label: 'Instagram'
    },
    {
        type: BusinessLinkType.TripAdvisor,
        label: 'TripAdvisor'
    },
    {
        type: BusinessLinkType.PhoneNumber,
        label: '-'
    },
];
function getBusinessLinks(userBusinessInfo) {
    return Object.values(BusinessLinkTemplates)
        .map(function (_a) {
        var type = _a.type, label = _a.label;
        var businessLink = (userBusinessInfo || []).find(function (x) { return x.type === type && x.isVisible && (x.url || '').length > 0; });
        if (!businessLink) {
            return null;
        }
        if (type === BusinessLinkType.PhoneNumber) {
            return {
                type: type,
                label: businessLink.url,
                href: "tel:".concat(businessLink.url)
            };
        }
        return {
            type: type,
            label: label,
            href: safeUrl(businessLink.url)
        };
    })
        .filter(Boolean);
}
exports.getBusinessLinks = getBusinessLinks;
function safeUrl(url) {
    var withProtocol = url.toLowerCase().startsWith('www') ? 'https://' + url : url;
    return withProtocol;
}
exports.safeUrl = safeUrl;
